import { useEffect, useMemo, useState } from "react";
import { getSigilTenant } from "models/configs";
import { DEFAULT_SIGIL_LINKS, SigilLinks } from "types/configs";

function mergeLinks(
  defaults: SigilLinks,
  overrides?: Partial<SigilLinks>,
): SigilLinks {
  if (!overrides) return defaults;

  return {
    ...defaults,
    ...overrides,
    website: {
      ...defaults.website,
      ...(overrides.website ?? {}),
    },
  };
}
const EXTERNAL_LINK_PROPS = {
  target: "_blank",
  rel: "noopener noreferrer",
} as const;

export type UseSigilLinksResult = {
  links: SigilLinks;

  mailto: (email: string, subject?: string) => string;
  externalLinkProps: typeof EXTERNAL_LINK_PROPS;
};

export function useSigilLinks(): UseSigilLinksResult {
  const [links, setLinks] = useState<SigilLinks>(DEFAULT_SIGIL_LINKS);

  useEffect(() => {
    const run = async () => {
      const sigilTenant = await getSigilTenant();
      const fromConfig = sigilTenant?.props?.links as
        | Partial<SigilLinks>
        | undefined;
      setLinks(mergeLinks(DEFAULT_SIGIL_LINKS, fromConfig));
    };
    void run();
  }, []);

  return useMemo(
    () => ({
      links,
      mailto: (email: string, subject?: string) =>
        `mailto:${email}${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`,
      externalLinkProps: EXTERNAL_LINK_PROPS,
    }),
    [links],
  );
}
